const primaryColors = {
  primary: '#197EF7',
  white: '#FFFFFF',
  black: '#000000',
  transparent: 'transparent',
};

const backgroundColor = {
  'primary/background': '#FCFCFF',
  'seconary/background': '#FFFFFF',
  'secondary/background': '#FFFFFF',
  'grey/dark/background': '#FDFDFD',
  'grey/light/background': '#EFF0F3',
};

const textColor = {
  'primary/text': '#444547',
  'grey/dark': '#212121',
  'grey/light': '#B8BABE',
  'primary/interactive': primaryColors.primary,
  'primary/inactive': '#CAE2FF',
};

const gradientColors = {
  'gradient/start': '#0B2946',
  'gradient/middle': '#0C4687',
  'gradient/end': primaryColors.primary,
  'gradient/blue': '0A0F14',
  // DEPRECATED
  'blue/gradient':
    'linear-gradient(161.39deg, #0A0F14 -20.38%, #0C4687 43.55%, #197EF7 100%)',
};

const messagingColors = {
  success: '#2ADF93',
  warning: '#FFBE40',
  error: '#D11B55',
  'error/opacity': '#D11B5533',
  'error/bright': '#D9004E',
};

const backgroundMessagingColors = {
  'background/success': 'rgba(42,223,147, .4)',
  'background/warning': 'rgba(255,190,64, .4)',
  'background/error': 'rgba(209,27,85, .4)',
};

export const colorsLight = {
  ...primaryColors,
  ...backgroundColor,
  ...textColor,
  ...gradientColors,
  ...messagingColors,
  ...backgroundMessagingColors,
};
